export default __webpack_public_path__ + "static/media/location.d406e358.svg";